import Switch from '@rio-cloud/rio-uikit/Switch';
import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';
import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface INewUiState {
    enabled: boolean;
    setEnabled: (enabled: boolean) => void;
}

export const useNewUi = create<INewUiState>()(
    persist(
        set => ({
            enabled: false,
            setEnabled: enabled => set({ enabled }),
        }),
        { name: 'uptime-new-ui' }
    )
);

export const NEW_UI_ROUTES = [
    '/control-tower/monitoring',
    '/control-tower/maintenance-monitoring',
    '/dealership/monitoring',
    '/dealership/maintenance-monitoring',
    '/fleet-manager/preventive-maintenance',
    '/fleet-manager/maintenance-monitoring',
    '/partnership/maintenance-monitoring',
];

export const isNewUiRoute = (pathname: string) =>
    NEW_UI_ROUTES.some(route => pathname === route || pathname.startsWith(`${route}/`));

interface INewUiGateProps {
    legacy: ReactNode;
    next: ReactNode;
}

export const NewUiGate = ({ legacy, next }: INewUiGateProps) => {
    const enabled = useNewUi(state => state.enabled);
    return <>{enabled ? next : legacy}</>;
};

export const NewUiSwitch = () => {
    const intl = useIntl();
    const enabled = useNewUi(state => state.enabled);
    const setEnabled = useNewUi(state => state.setEnabled);
    const label = intl.formatMessage({ id: 'intl-msg:newUi.label' });

    return (
        <div
            className='display-flex align-items-center height-100pct padding-x-10'
            title={intl.formatMessage({ id: 'intl-msg:newUi.tooltip' })}
        >
            <Switch
                keyName='new-ui-switch'
                checked={enabled}
                onChange={setEnabled}
                enabledText={label}
                disabledText={label}
                minWidth={80}
            />
        </div>
    );
};
